/* Promo bar countdown (sections/promo-bar-bento.liquid).

   `data-end` is a wall-clock time ("YYYY-MM-DD HH:MM[:SS]") in the IANA zone
   `data-tz`; toInstant() finds the UTC instant that reads so in that zone,
   through Intl (DST included). The timer ticks on the second; the next tick
   is timed from the time left, so a throttled background tab catches up
   instead of drifting. At the end the bar hides (`data-hide-ended`) or only
   the timer does — never in the theme editor, where the merchant must still
   see the bar.

   `--m-announcement-height` (read by the header overlay, header-bento.css)
   follows the bar's height while it shows. A bar inside the page
   (`data-promo-inline`, the promo card of main-product-bento) only counts down. */
(function () {
  if (window.LeonartoPromoBar) return;
  window.LeonartoPromoBar = true;

  var PATTERN = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?$/;
  var bars = [];

  /* Offset of `zone` at the instant `time` (ms), as "wall clock - UTC". */
  function zoneOffset(time, zone) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: zone,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
      .formatToParts(new Date(time))
      .forEach(function (part) {
        parts[part.type] = Number(part.value);
      });
    var wall = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return wall - Math.floor(time / 1000) * 1000;
  }

  function toInstant(text, zone) {
    var match = PATTERN.exec(String(text || '').trim());
    if (!match) return NaN;
    var guess = Date.UTC(+match[1], +match[2] - 1, +match[3], +match[4], +match[5], +(match[6] || 0));
    try {
      var first = guess - zoneOffset(guess, zone);
      // Across a DST change the offset at the answer can differ from the
      // offset at the guess: one more pass settles it.
      return guess - zoneOffset(first, zone);
    } catch (error) {
      return NaN; // an unknown zone
    }
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function syncHeight() {
    var height = 0;
    bars.forEach(function (bar) {
      if (bar.el.hasAttribute('data-promo-inline')) return;
      if (!bar.el.hidden && document.documentElement.contains(bar.el)) height += bar.el.offsetHeight;
    });
    document.documentElement.style.setProperty('--m-announcement-height', height + 'px');
  }

  function start(el) {
    if (el.dataset.promoInit) return;
    el.dataset.promoInit = 'true';
    var timer = el.querySelector('[data-promo-timer]');
    var end = toInstant(el.getAttribute('data-end'), el.getAttribute('data-tz') || 'Europe/Warsaw');
    var bar = { el: el, timeout: null };
    bars.push(bar);
    if (!timer || isNaN(end)) {
      syncHeight();
      return;
    }

    var days = timer.querySelector('[data-promo-d]');
    var daysWrap = timer.querySelector('[data-promo-days-wrap]');
    var hours = timer.querySelector('[data-promo-h]');
    var minutes = timer.querySelector('[data-promo-m]');
    var seconds = timer.querySelector('[data-promo-s]');
    var ends = timer.querySelector('[data-promo-ends]');
    if (ends) {
      try {
        var date = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
          dateStyle: 'long',
          timeStyle: 'short'
        }).format(new Date(end));
        ends.textContent = (ends.getAttribute('data-template') || '[date]').replace('[date]', date);
      } catch (error) {
        /* No end date for screen readers; the bar still works. */
      }
    }
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        if (inEditor) {
          timer.hidden = false;
          days.textContent = '0';
          hours.textContent = minutes.textContent = seconds.textContent = '00';
        } else if (el.hasAttribute('data-hide-ended')) {
          el.hidden = true;
        } else {
          timer.hidden = true;
        }
        syncHeight();
        return;
      }
      var total = Math.floor(left / 1000);
      var d = Math.floor(total / 86400);
      days.textContent = String(d);
      if (daysWrap) daysWrap.hidden = d === 0;
      hours.textContent = pad(Math.floor((total % 86400) / 3600));
      minutes.textContent = pad(Math.floor((total % 3600) / 60));
      seconds.textContent = pad(total % 60);
      if (timer.hidden) {
        timer.hidden = false;
        syncHeight();
      }
      bar.timeout = setTimeout(tick, (left % 1000) + 20);
    }
    tick();
    syncHeight();
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-promo-bar]'), start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  window.addEventListener('resize', syncHeight);
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    bars = bars.filter(function (bar) {
      if (!event.target.contains(bar.el)) return true;
      clearTimeout(bar.timeout);
      return false;
    });
    setTimeout(syncHeight, 0);
  });
})();
